// extracted by mini-css-extract-plugin
export var active = "_gq-7";
export var blink = "_gq-8";
export var dropDownSelector = "_gq-4";
export var dropDownWrapper = "_gq-3";
export var fakeCursor = "_gq-6";
export var fontSizeButton = "_gq-9";
export var formQuillEditor = "_gq-0";
export var pressed = "_gq-a";
export var qlBlank = "_gq-1";
export var textFormattingToolbar = "_gq-2";
export var textToolbarOption = "_gq-5";